var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeedle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 145,
    viewBox: "0 0 10 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 3.53027,
    y: 0.639893,
    width: 2.2277,
    height: 118,
    fill: "#6AAFDC",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M0 123L4.64426 117.735L9.28851 123V129.492H0V123Z",
    fill: "#6AAFDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedle);
export default __webpack_public_path__ + "static/media/Needle.c904a273a051509459b9f8530792f931.svg";
export { ForwardRef as ReactComponent };